var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"mousemove":_vm.handleMouseMove,"mouseleave":_vm.resetParallax}},[_c('h1',{staticClass:"slogan-text",style:(_vm.parallaxStyle)},[_vm._v(" FIELD FELLAS ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }